<template>
  <div class="recommendation flex column" v-bind:class="{ 'is-active': isActive, 'is-disabled': isDisabled }">
    <div class="summary box flex gaps cursor-pointer">
      <el-tooltip class="item" effect="dark" placement="bottom" :content="disabledTooltip" :enterable="false">
        <el-checkbox class="box flex top" v-model="selection" :disabled="isDisabled || !showDismiss()"></el-checkbox>
      </el-tooltip>
      <div class="description box grow word-break" v-on:click="select($event, recommendation)">
        {{ recommendation.name }}
        <div class="statuses">
          <el-tag v-if="recommendation.isStatus('incompatible')" size="mini" type="info">incompatible agent</el-tag>
          <el-tag v-if="recommendation.isStatus('invalid')" size="mini" type="info">expired</el-tag>
          <el-tag v-if="recommendation.isStatus('pending')" size="mini" type="warning">in progress</el-tag>
          <el-tag v-if="recommendation.isStatus('executed')" size="mini">executed</el-tag>
          <el-tag v-if="recommendation.isStatus('failed')" size="mini" type="danger">failed</el-tag>
          <el-tag v-if="recommendation.isStatus('done')" size="mini" type="success">done</el-tag>
          <el-tag v-if="recommendation.isStatus('dismissed')" size="mini" type="info">dismissed</el-tag>
        </div>
      </div>
      <div v-if="!isActive" class="status box flex gaps top">
        <div class="box" v-on:click="select($event, recommendation)">
          <i :class="'material-icons ' + recommendation.priority">{{
            recommendation.priority === 'low' ? 'south' : 'north'
          }}</i>
        </div>
        <div class="box">
          <el-dropdown
            :show-timeout="50"
            :disabled="isDisabled"
            :hide-on-click="false"
            trigger="click"
            placement="bottom-start"
            @command="handleActionCommand"
          >
            <i class="material-icons actions">more_vert</i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="view-details">View Details</el-dropdown-item>
              <el-divider></el-divider>
              <el-dropdown-item command="execute" v-show="showExecute()" :disabled="isDisabled">{{
                getExecuteActionText()
              }}</el-dropdown-item>
              <el-dropdown-item command="dismiss" v-show="showDismiss()" :disabled="isDisabled"
                >Dismiss</el-dropdown-item
              >
              <el-dropdown-item command="done" v-show="showDone()" :disabled="isDisabled"
                >Mark as done</el-dropdown-item
              >
              <el-dropdown-item command="reset" v-show="showReset()" :disabled="isDisabled"
                >Reset to Awaiting Action</el-dropdown-item
              >
              <el-dropdown-item v-show="displayQuarantinedFilesLink()" command="quarantined-files"
                >See in Quarantined Files</el-dropdown-item
              >
              <el-dropdown-item v-show="displayNetworkRestrictionsLink()" command="network-restrictions"
                >See in Network Restrictions</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div v-if="isActive" class="status box top"><i @click.stop="close" class="material-icons">close</i></div>
    </div>
    <div v-if="isActive" class="details box flex box column">
      <div class="box" v-if="recommendation.latestAction.error">
        <div class="error">{{ recommendation.latestAction.error }}</div>
      </div>
      <div class="box" v-if="this.recommendation.isStatus('incompatible')">
        <div class="error">The agent on this host cannot execute this recommendation.</div>
      </div>
      <div class="box" v-if="this.recommendation.isStatus('invalid')">
        <div class="error">This is no longer a valid recommendation.</div>
      </div>
      <div class="box" v-if="this.recommendation.isStatus('manual')">
        <div>This is a non-actionable recommendation.</div>
      </div>
      <div class="description flex box gaps grow">
        <div class="box flex gaps grow">
          <div class="box top">
            <i :class="'material-icons ' + recommendation.priority">{{
              recommendation.priority === 'low' ? 'south' : 'north'
            }}</i>
          </div>
          <div class="flex column">
            <span class="box uppercase bold">{{ recommendation.priority }}: Justification for Priority </span>
            <div class="box">{{ recommendation.justification }}</div>
          </div>
        </div>
      </div>
      <div class="actions box flex" v-show="showExecute() || showDismiss() || showDone() || showReset()">
        <el-button size="small" @click="execute" v-show="showExecute()" :disabled="isDisabled">
          {{ getExecuteActionText() }}
        </el-button>
        <el-button size="small" @click="dismiss" v-show="showDismiss()" :disabled="isDisabled">Dismiss</el-button>
        <el-button size="small" @click="done" v-show="showDone()" :disabled="isDisabled">Mark as done</el-button>
        <el-button size="small" @click="reset" v-show="showReset()" :disabled="isDisabled"
          >Reset to Awaiting Action</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BlockingResponseFeedItem',
  components: {},
  props: {
    active: {
      type: String,
      default () {
        return ''
      }
    },
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    },
    selected: {
      type: Array,
      default () {
        return []
      }
    },
    recommendation: {
      type: Object,
      default () {
        return {}
      }
    },
    mitigationProgressState: {
      type: String,
      default () {
        return 'mitigation-not-started'
      }
    }
  },
  data () {
    return {
      isExecuting: false,
      isConfirmation: false
    }
  },
  created () {},
  methods: {
    close () {
      this.$emit('close')
    },
    select ($event, recommendation) {
      switch ($event.target.className) {
        case 'el-checkbox__original':
        case 'el-checkbox__inner':
          return
        default:
          this.$emit('activate')
          break
      }
    },
    handleActionCommand (command) {
      switch (command) {
        case 'execute':
          this.confirmActionCommand('execute', 'execute')
          break
        case 'dismiss':
          this.confirmActionCommand('dismiss', 'dismiss')
          break
        case 'done':
          this.confirmActionCommand('done', 'mark as done')
          break
        case 'reset':
          this.confirmActionCommand('reset', 'reset to awaiting action')
          break
        case 'view-details':
          this.$emit('activate')
          break
        case 'network-restrictions':
          window.open('#/network-restrictions')
          break
        case 'quarantined-files':
          window.open('#/quarantined-files')
          break
        default:
          break
      }
    },
    confirmActionCommand (command, message) {
      const h = this.$createElement
      this.$msgbox({
        title: 'Confirm Action',
        message: h('p', null, 'Are you sure you want to ' + message + ' this recommendation?'),
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.$emit(command)
            this.isConfirmation = false
            this.isExecuting = true
            done()
          } else {
            done()
            this.isConfirmation = false
          }
        }
      })
      this.isConfirmation = true
    },
    execute () {
      this.handleActionCommand('execute')
    },
    dismiss () {
      this.handleActionCommand('dismiss')
    },
    done () {
      this.handleActionCommand('done')
    },
    reset () {
      this.handleActionCommand('reset', 'reset')
    },
    showExecute () {
      if (
        !this.recommendation.isStatus('invalid') &&
        !this.recommendation.isStatus('manual') &&
        !this.recommendation.isStatus('incompatible')
      ) {
        if (
          this.recommendation.isStatus('failed') ||
          this.recommendation.isStatus('default') ||
          this.recommendation.isStatus('reversible')
        ) {
          if (this.mitigationProgressState !== 'mitigated') {
            return true
          }
        }
      }
      return false
    },
    showDismiss () {
      if (!this.recommendation.isStatus('invalid')) {
        if (
          this.recommendation.isStatus('failed') ||
          this.recommendation.isStatus('default') ||
          this.recommendation.isStatus('incompatible') ||
          this.recommendation.isStatus('reversed')
        ) {
          return true
        }
      }
      return false
    },
    showDone () {
      if (this.recommendation.isStatus('default') && this.recommendation.isStatus('manual')) {
        return true
      }
      return false
    },
    showReset () {
      if (this.mitigationProgressState !== 'mitigated') {
        if (this.recommendation.isStatus('done') || this.recommendation.isStatus('dismissed')) {
          return true
        }
      }
      return false
    },
    displayQuarantinedFilesLink () {
      if (this.recommendation.isStatus('executed')) {
        if (this.recommendation.type === 'quarantine-file' || this.recommendation.type === 'restore-file') {
          return true
        }
      }
      return false
    },
    displayNetworkRestrictionsLink () {
      if (this.recommendation.isStatus('executed')) {
        if (this.recommendation.type === 'block-network' || this.recommendation.type === 'unblock-network') {
          return true
        }
      }
      return false
    },
    getExecuteActionText () {
      let recommendation = this.recommendation
      if (recommendation.isStatus('failed')) {
        return 'Retry'
      }
      switch (recommendation.latestAction.actionType) {
        case 'block-network':
          return 'Block'
        case 'unblock-network':
          return 'Unblock'
        case 'quarantine-file':
          return 'Quarantine'
        case 'restore-file':
          return 'Restore'
        default:
          return 'Execute'
      }
    }
  },
  watch: {
    trailDetailsStatus (newVal) {
      if (newVal === 'saved' && this.isConfirmation == false) {
        this.isExecuting = false
      }
    }
  },
  computed: {
    ...mapGetters(['trailDetailsStatus']),
    selection: {
      get () {
        let selected = false
        this.selected.forEach(item => {
          if (item === this.recommendation.iocHashIndex) {
            selected = true
          }
        })
        return selected
      },
      set () {
        this.$emit('select', this.recommendation)
      }
    },
    isActive: {
      get () {
        return this.active === this.recommendation.iocHashIndex
      }
    },
    isDisabled: {
      get () {
        return this.disabled || this.isExecuting || this.recommendation.isStatus('pending')
      }
    },
    disabledTooltip: {
      get () {
        let message = 'Select this recommendation for bulk dismissal'
        if (this.recommendation.isStatus('invalid')) {
          message = 'This recommendation is no longer valid'
        } else if (this.recommendation.isStatus('executed')) {
          message = 'This recommendation has already been executed'
        } else if (this.isDisabled) {
          message = 'This recommendation can not currently be selected'
        }
        return message
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.recommendation {
  .summary {
    padding: 10px 15px 5px 15px;
    border-top: solid 1px #f0f0f0;

    .text-truncate {
      width: 230px;
    }

    .description .el-tag {
      margin: 5px 0 0 0;
      font-size: 10px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  .status .actions {
    opacity: 0.25;
    border-radius: 50%;

    &:hover {
      color: #ffffff;
      background: #409eff;
    }
  }

  &:hover .status .actions {
    opacity: 1;
  }

  &.is-disabled {
    color: #888888;
    background: #fafafa;
  }

  &.is-active .summary {
    color: #ffffff;
    background: #0090ff;
  }

  .details {
    border-left: solid 3px #0090ff;

    > div {
      padding: 10px 10px 10px 38px;
      border-bottom: solid 1px #f0f0f0;
    }

    .material-icons {
      margin-top: 4px;
      color: #666666;
      font-size: 15px;
      font-weight: bold;

      &.high {
        color: #ff0000;
      }

      &.medium {
        color: #ff6633;
      }

      &.low {
        color: #ffaa66;
      }
    }

    .description {
      strong {
        color: #333333;
      }
    }
  }
}

.recommendation .summary.is-active,
.recommendation:first-child .summary {
  border: none;
}

.status .material-icons {
  margin: 5px 0 0 0;
  font-size: 15px;
  font-weight: bold;

  &.high {
    color: #ff0000;
  }

  &.medium {
    color: #ff6633;
  }

  &.low {
    color: #ffaa66;
  }
}

>>> .el-checkbox__inner {
  background: rgba(1, 1, 1, 0);
}

>>> .el-divider--horizontal {
  margin: 10px 0;
}

.error {
  display: block;
  color: var(--text-color-danger) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/feed/BlockingResponseFeedItem.vue